// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { spacer24, screenSmMax, spacer16 } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../Contentful/ContentfulImage';
import { HeadlineWithSupertextComponent } from './HeadlineWithSupertext';
import { ImageAspectBox21x9 } from './Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FeaturedContent = styled.div.withConfig({
  displayName: "FeaturedContentHeadline__FeaturedContent",
  componentId: "sc-10cz60c-0"
})(["background-color:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
});
var HeaderContent = styled.div.withConfig({
  displayName: "FeaturedContentHeadline__HeaderContent",
  componentId: "sc-10cz60c-1"
})(["display:flex;flex-direction:column;padding-top:", ";@media (max-width:", "){padding-top:0px;padding-bottom:", ";flex-direction:column-reverse;}"], function (props) {
  return props.padding;
}, screenSmMax, spacer16);
var ImageContainer = styled(ImageAspectBox21x9).withConfig({
  displayName: "FeaturedContentHeadline__ImageContainer",
  componentId: "sc-10cz60c-2"
})([""]);
var InnerText = styled.div.withConfig({
  displayName: "FeaturedContentHeadline__InnerText",
  componentId: "sc-10cz60c-3"
})(["max-width:815px;padding-top:", ";@media (max-width:", "){padding-top:0;}"], spacer24, screenSmMax);
export var FeaturedContentHeadline = function FeaturedContentHeadline(_ref3) {
  var _ref3$supertext = _ref3.supertext,
      supertext = _ref3$supertext === void 0 ? '' : _ref3$supertext,
      _ref3$headline = _ref3.headline,
      headline = _ref3$headline === void 0 ? '' : _ref3$headline,
      image = _ref3.image,
      useFeaturedContentHeadline = _ref3.useFeaturedContentHeadline,
      _ref3$caption = _ref3.caption,
      caption = _ref3$caption === void 0 ? '' : _ref3$caption;
  var padding = image ? "".concat(spacer24) : '0px';
  return /*#__PURE__*/_jsx(FeaturedContent, {
    children: /*#__PURE__*/_jsxs(HeaderContent, {
      padding: padding,
      children: [image && /*#__PURE__*/_jsx(ImageContainer, {
        children: /*#__PURE__*/_jsx(ContentfulImage, {
          asset: image,
          caption: caption
        })
      }), useFeaturedContentHeadline && headline && /*#__PURE__*/_jsx(InnerText, {
        children: /*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
          supertext: supertext,
          headline: headline
        })
      })]
    })
  });
};